<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <OrganizationalTree ref="organizationalTree" :nodeSelectProp='getNode' :neid="neid" :treeFresh='treeFresh'>
        <!--<template v-slot:organizationalIcon_solt>-->
        <!--<OrganizationalIcon ref="organizationalIcon" :treeFresh='treeFresh'></OrganizationalIcon>-->
      <!--</template>-->
      </OrganizationalTree>
    </template>
    <template v-slot:right_view>
      <GroupTableMenu @methodEnum='methodEnum' ref="groupTableMenu"></GroupTableMenu>
      <ImsGroupTable ref="grouptable"></ImsGroupTable>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../../layouts/BasicLayout';
import OrganizationalTree from '../../../../components/subscriberconfig/util/OrganizationalTree';
// import OrganizationalIcon from '../../../../components/subscriberconfig/util/OrganizationalIcon';
import GroupTableMenu from '../../../../components/subscriberconfig/imsSubscriber/group/GroupTableMenu';
import ImsGroupTable from '../../../../components/subscriberconfig/imsSubscriber/group/ImsGroupTable';

export default {
  name: 'groupManagement',
  components: {
    BasicLayout,
    OrganizationalTree,
    // OrganizationalIcon,
    ImsGroupTable,
    GroupTableMenu,
  },
  data() {
    return {
      neid: null,
      left: {
        show: true,
        name: this.$t('SubscriberIms.organization')
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t('SubscriberIms.menuTitle')
      },
    };
  },
  props: [
    'node'
  ],
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'add':
          this.$refs.grouptable.openAddImsGroupPage(opcode);
          break;
        case 'mod':
          this.$refs.grouptable.openModImsGroupPage(opcode);
          break;
        case 'batchAdd':
          this.$refs.grouptable.openAddImsGroupPage(opcode);
          break;
        case 'batchMod':
          this.$refs.grouptable.openModImsGroupPage(opcode);
          break;
        case 'del':
          this.$refs.grouptable.delImsGroups();
          break;
        case 'refresh':
          this.$refs.grouptable.clearQryParam();
          this.$refs.grouptable.getGridData(this.node);
          break;
        case 'addGroupMember':
          this.$refs.grouptable.openAddImsGroupMemberPage();
          break;
        case 'qryGroupMember':
          this.$refs.grouptable.openQryImsGroupMemberPage();
          break;
        case 'import':
          this.$refs.grouptable.openImportGroupPage();
          break;
        case 'export':
          this.$refs.grouptable.exportImsGroup();
          break;
        case 'search':
          this.$refs.grouptable.openQryImsGroupPage();
          break;
        default:
      }
    },
    getNode(node) {
      this.$refs.grouptable.clearQryParam();
      this.$refs.grouptable.getGridData(node);
      this.node = node;
    },
    treeFresh(node) {
      this.$refs.grouptable.clearGridData();
      // 若组织架构刷新后有默认值则执行数据查询
      this.$refs.grouptable.clearQryParam();
      this.$refs.grouptable.getGridData(node);
    },
  },
  mounted() {
    this.$refs.organizationalTree.getOrganizationalTree();
  }
};
</script>

<style scoped>

</style>
